import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, isRef as _isRef, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "embcropper_modal_container" }
const _hoisted_2 = { class: "embcropper_modal_body" }
const _hoisted_3 = { class: "embtoolbox" }
const _hoisted_4 = { class: "emb-card flexCol" }
const _hoisted_5 = {
  id: "crop-container",
  class: "embcropper_modal_cropbox"
}
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { class: "embcropper_modal_footer" }
const _hoisted_8 = ["disabled"]

import html2canvas from 'html2canvas';
import { ModalType, Settings } from '@/constant';
import { isIOS, isMobile, isTablet } from 'mobile-device-detect';
import PlusCircleIcon from '@/assets/icons/PlusCircle.vue';
import MinusCircleIcon from '@/assets/icons/MinusCircle.vue';
import Loader from '../Loader.vue';
import {
  closeDragElement,
  fitSVGToModal,
  getTransformMatrix,
  normalZoomIn,
  tranformOriginOfElement,
} from '@/core';

import TownHomeLevel from '../TownHomeLevel.vue';
import { ref, toRefs, watch, render, computed, onMounted, inject } from 'vue';
import emitter from '@/mitt';


export default /*@__PURE__*/_defineComponent({
  __name: 'PlatMapPrintModal',
  props: {
    isOpenPrintModal: { type: Boolean },
    underlay_on: { type: Boolean },
    showHomeLevel: { type: Boolean },
    actualLevels: {},
    activeLevel: {},
    showModal: { type: Boolean }
  },
  emits: ['closeModal', 'printPDF'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const clonedSVG: any = ref('');
const pos1 = ref(0);
const pos2 = ref(0);
const pos3 = ref(0);
const pos4 = ref(0);
const evCache: any = ref<any[]>();
const prevDiff = ref(-1);
const isDisabledZoomIn = ref(false);
const isDisabledZoomOut = ref(false);
const $element = ref<HTMLElement>();
const loading = ref(false);
const svgZoom = ref(1);
const {
  isOpenPrintModal,
  underlay_on,
  showHomeLevel,
  actualLevels,
  activeLevel,
  showModal,
} = toRefs(props);

const mode = inject('mode', ref(''));
const isSalesOrLandView = computed(() => mode.value === 'sales' || mode.value === 'land');

const emits = __emit;

onMounted(() => {
  emitter.on('communityUpdated', resetToDefault);
  emitter.on('newDivisonSelected', resetToDefault);
});

const resetToDefault = () => {
  isDisabledZoomIn.value = false;
  isDisabledZoomOut.value = false;
};

const resetTransform = () => {
  clonedSVG.value = '';
  pos1.value = 0;
  pos2.value = 0;
  pos3.value = 0;
  pos4.value = 0;
  loading.value = false;
  evCache.value = [];
  prevDiff.value = -1;
  isDisabledZoomIn.value = false;
  isDisabledZoomOut.value = false;
  svgZoom.value = 1;
};

const printPdf = (platmap: string) => {
  emits('printPDF', platmap);
  resetTransform();
};

const registerTouchEvents = () => {
  const overlayContainer = document.querySelector('#crop') as HTMLElement;
  $element.value = overlayContainer;
  isDisabledZoomOut.value = true;
  fitSVGToModal(svgZoom.value, isSalesOrLandView.value);

  if (isMobile || isTablet || isIOS) {
    overlayContainer.ontouchstart = dragMouseDown;
  } else {
    overlayContainer.onmousedown = dragMouseDown;
  }
  touchWheelEvents(overlayContainer);
};

const renderSvg = () => {
  let element = underlay_on.value
    ? (document.getElementById('map') as HTMLElement)
    : (document.getElementById('plan-overlay') as HTMLElement);
  let svg = element.getElementsByTagName('svg')[0];
  const clone = svg.cloneNode(true) as HTMLElement;
  clone.id = 'print-modal-svg';
  clonedSVG.value = clone?.outerHTML;

  setTimeout(() => {
    registerTouchEvents();
  }, 1000);
};

watch(isOpenPrintModal, (value: any) => {
  if (value) {
    renderSvg();
  }
});

watch(isDisabledZoomIn, () => {
  let zoomIn = document.querySelector('#print-modal-zoom-in') as HTMLDivElement;
  if (isDisabledZoomIn.value) {
    zoomIn.style.pointerEvents = 'none';
    zoomIn.style.opacity = '0.5';
  } else {
    zoomIn.style.pointerEvents = 'auto';
    zoomIn.style.opacity = '1';
  }
});

watch(isDisabledZoomOut, () => {
  let zoomOut = document.querySelector(
    '#print-modal-zoom-out'
  ) as HTMLDivElement;
  if (isDisabledZoomOut.value) {
    zoomOut.style.pointerEvents = 'none';
    zoomOut.style.opacity = '0.5';
  } else {
    zoomOut.style.pointerEvents = 'auto';
    zoomOut.style.opacity = '1';
  }
});

const scrollCallback = (e) => {
  e.preventDefault();
  let delta = (e.deltaY || -e.wheelDelta || e.detail) >> 10 || 1;
  svgZoomIn(e.wheelDelta > 0 ? 0.5 : -0.5);
};

const svgZoomIn = (zoomStep = 1) => {
  zoomIn(zoomStep);
};

const svgZoomOut = (zoomStep = 1) => {
  svgZoomIn(zoomStep * -1);
};

const zoomIn = (zoomStep: number) => {
  const zoomParams = normalZoomIn(svgZoom.value, zoomStep);
  const svg = document.getElementById('crop')?.getElementsByTagName('svg')[0];
  isDisabledZoomIn.value = zoomParams.isDisabledZoomIn;
  isDisabledZoomOut.value = zoomParams.isDisabledZoomOut;
  svgZoom.value = zoomParams.svgZoom;
  tranformOriginOfElement(svg, svgZoom.value, svgZoom.value);
};

const touchWheelEvents = (overlayContainer) => {
  if ('ontouchstart' in window) {
    initPinchInPinchOut(overlayContainer);
  } else {
    overlayContainer.addEventListener(
      'mousewheel',
      (e) => {
        scrollCallback(e);
      },
      {
        passive: false,
      }
    );
    overlayContainer.addEventListener(
      'DOMMouseScroll',
      (e) => {
        scrollCallback(e);
      },
      {
        passive: false,
      }
    );
  }
};

const initPinchInPinchOut = (el) => {
  el.onpointerdown = pointerdown_handler;
  el.onpointermove = pointermove_handler;
  el.onpointerup = pointerup_handler;
  el.onpointercancel = pointerup_handler;
  el.onpointerout = pointerup_handler;
  el.onpointerleave = pointerup_handler;
};

const pointerdown_handler = (ev) => {
  evCache.value.push(ev);
};

const callZoom = (curDiff) => {
  if (prevDiff.value > 0) {
    if (curDiff > prevDiff.value) {
      svgZoomIn(0.02);
    }
    if (curDiff < prevDiff.value) {
      svgZoomOut(0.02);
    }
  }
};

const pointermove_handler = (ev) => {
  for (let i = 0; i < evCache.value.length; i++) {
    if (ev.pointerId == evCache.value[i].pointerId) {
      evCache.value[i] = ev;
      break;
    }
  }
  if (evCache.value.length == 2) {
    let curDiff = Math.abs(evCache.value[0].clientX - evCache.value[1].clientX);
    callZoom(curDiff);
    prevDiff.value = curDiff;
  } else {
    prevDiff.value = -1;
  }
};

const pointerup_handler = (ev) => {
  remove_event(ev);
  if (evCache.value.length < 2) {
    prevDiff.value = -1;
  }
};

const remove_event = (ev) => {
  for (let i = 0; i < evCache.value.length; i++) {
    if (evCache.value[i].pointerId == ev.pointerId) {
      evCache.value.splice(i, 1);
      break;
    }
  }
};

const dragMouseDown = (e) => {
  e = e || window.event;
  if (isMobile) {
    const touch = e.touches[0] || e.changedTouches[0];
    pos3.value = touch.clientX;
    pos4.value = touch.clientY;
    document.ontouchend = closeDragElement;
    document.ontouchmove = elementDrag;
  } else {
    pos3.value = e.clientX;
    pos4.value = e.clientY;
    document.onmouseup = closeDragElement;
    document.onmousemove = elementDrag;
  }
};

const elementDrag = (e) => {
  e = e || window.event;
  if (isMobile) {
    const touch = e.touches[0] || e.changedTouches[0];
    pos1.value = pos3.value - touch.clientX;
    pos2.value = pos4.value - touch.clientY;
    pos3.value = touch.clientX;
    pos4.value = touch.clientY;
  } else {
    pos1.value = pos3.value - e.clientX;
    pos2.value = pos4.value - e.clientY;
    pos3.value = e.clientX;
    pos4.value = e.clientY;
  }
  if ($element.value) {
    $element.value.style.top = $element.value.offsetTop - pos2.value + 'px';
    $element.value.style.left = $element.value.offsetLeft - pos1.value + 'px';
  }
};

const closeModal = (modalName: string) => {
  emits('closeModal', modalName);
};

const closePrintModal = () => {
  resetTransform();
  closeModal(ModalType.CROPPING_TOOL);
};

// JPEG has no alpha channel, so any transparent pixel in the captured canvas is
// flattened to RGB(0,0,0) and shows up as black in the generated PDF. Compositing
// onto an opaque white canvas first keeps the padding around the map white.
const flattenOnWhite = (source: HTMLCanvasElement): HTMLCanvasElement => {
  const target = document.createElement('canvas');
  target.width = source.width;
  target.height = source.height;

  const ctx = target.getContext('2d');
  if (!ctx) {
    return source;
  }

  ctx.fillStyle = '#ffffff';
  ctx.fillRect(0, 0, target.width, target.height);
  ctx.drawImage(source, 0, 0);

  return target;
};

// Sales/land run inside the Salesforce iframe, where that pairing comes apart and
// produces exactly that bottom/right clipping. They use html2canvas' default
// renderer instead, which resolves the element's bounds itself and therefore needs
// no offsets - correct by construction rather than by cancellation. It rasterises
// an inline <svg> by serialising the whole element to a data: URL, so the plat's
// clip paths and status patterns still render, and a data: URL cannot taint the
// canvas that toDataURL() reads back.
//
// Customer mode is left on the original options, unchanged.
const captureOptions = (element: HTMLElement) => {
  if (isSalesOrLandView.value) {
    return {
      logging: false,
      imageTimeout: 0,
      useCORS: true,
      backgroundColor: '#ffffff',
    };
  }

  // Scroll first, then measure: html2canvas resolves the element's bounds in a
  // cloned iframe that is always at scroll 0, so an offset measured against a
  // scrolled page leaves the capture misaligned.
  window.scrollTo(0, 0);
  const rect = element.getBoundingClientRect();

  return {
    height: element.offsetHeight,
    width: element.offsetWidth,
    logging: false,
    imageTimeout: 0,
    useCORS: true,
    foreignObjectRendering: true,
    backgroundColor: '#ffffff',
    x: -rect.x,
    y: -rect.y,
    scrollX: 0,
    scrollY: 0,
    allowTaint: true,
  };
};

// Same vendor list tranformOriginOfElement() writes the zoom scale with.
const TRANSFORM_PROPERTIES = [
  '-webkit-transform',
  '-moz-transform',
  '-ms-transform',
  '-o-transform',
  'transform',
];

// The zoom buttons scale the <svg> itself. html2canvas' default renderer sizes an
// inline <svg> from its bounding rect, and that rect includes the scale, so it
// serialises the plat at zoom x crop-box size: ~12MP at zoom 4, ~62MP at zoom 9.
// Past roughly 7MP the SVG image never decodes, html2canvas silently skips it and
// the PDF comes out blank; below that the plat is effectively scaled twice and the
// wrong region prints.
//
// Parking the scale on #crop for the duration of the capture keeps the <svg> at its
// on-screen size, so the raster stays small at every zoom level. #crop exactly
// contains the svg, so scaling either one about its centre is visually identical -
// and #crop's own drag offset lives in top/left, which composes with a transform
// rather than conflicting with it.
const captureWithZoomOffSvg = async (
  capture: () => Promise<HTMLCanvasElement>
): Promise<HTMLCanvasElement> => {
  const div = document.getElementById('crop');
  const svg = div?.getElementsByTagName('svg')[0];
  const transform = svg ? getComputedStyle(svg).transform : '';

  if (!div || !svg || !transform || transform === 'none') {
    return capture();
  }

  const savedSvg = TRANSFORM_PROPERTIES.map((name) => svg.style.getPropertyValue(name));
  const savedDiv = TRANSFORM_PROPERTIES.map((name) => div.style.getPropertyValue(name));

  TRANSFORM_PROPERTIES.forEach((name) => svg.style.removeProperty(name));
  div.style.setProperty('transform', transform);

  try {
    return await capture();
  } finally {
    TRANSFORM_PROPERTIES.forEach((name, index) => {
      svg.style.setProperty(name, savedSvg[index]);
      div.style.setProperty(name, savedDiv[index]);
    });
  }
};

const captureCropBox = (element: HTMLElement): Promise<HTMLCanvasElement> => {
  const capture = () => html2canvas(element, captureOptions(element));
  return isSalesOrLandView.value ? captureWithZoomOffSvg(capture) : capture();
};

const printMap = () => {
  loading.value = true;
  const loadTimer = setTimeout(() => {
    const element = document.getElementById('crop-container') as HTMLElement;

    captureCropBox(element)
      .then((canvas) => {
        const base64 = flattenOnWhite(canvas).toDataURL('image/jpeg', 0.9);
        printPdf(base64);
        loading.value = false;
      })
      .catch(() => {
        // Without this the spinner never clears and the button stays disabled,
        // leaving the user with no way to retry.
        loading.value = false;
      });
    clearTimeout(loadTimer);
  }, 100);
};

const modalClasses = computed(() => {
  return {
    embcropper_modal: true,
  };
});

return (_ctx: any,_cache: any) => {
  const _component_VueFinalModal = _resolveComponent("VueFinalModal")!

  return (_openBlock(), _createBlock(_component_VueFinalModal, {
    name: "cropping-tool",
    modelValue: _unref(showModal),
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(showModal) ? (showModal).value = $event : null)),
    class: _normalizeClass(modalClasses.value),
    clickToClose: false,
    width: "100%",
    height: "100%"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("i", {
            class: "emb_closeicon is-gray",
            onClick: closePrintModal
          }),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", {
                class: "dsize tbIcon zoom_in",
                id: "print-modal-zoom-in",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (svgZoomIn(1)))
              }, [
                _createVNode(PlusCircleIcon)
              ]),
              _createElementVNode("div", {
                class: "dsize tbIcon zoom_out",
                id: "print-modal-zoom-out",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (svgZoomOut(1)))
              }, [
                _createVNode(MinusCircleIcon)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", {
              id: "crop",
              style: {"width":"100%","height":"100%","overflow":"hidden"},
              innerHTML: clonedSVG.value
            }, null, 8, _hoisted_6),
            (_unref(showHomeLevel))
              ? (_openBlock(), _createBlock(TownHomeLevel, {
                  key: 0,
                  levels: _unref(actualLevels),
                  class: "customer-mode",
                  printSelectedLevel: _unref(activeLevel),
                  ref: "levelSelector"
                }, null, 8, ["levels", "printSelectedLevel"]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _cache[4] || (_cache[4] = _createElementVNode("p", null, " Zoom in to select the area of the plat to be printed. The plat legend will be automatically included in the printout. ", -1)),
          _createElementVNode("button", {
            class: "btn relative",
            disabled: loading.value,
            onClick: printMap
          }, [
            _cache[3] || (_cache[3] = _createTextVNode(" Print Selected Area ", -1)),
            _createElementVNode("span", {
              class: _normalizeClass({ loading: !!loading.value })
            }, [
              (loading.value)
                ? (_openBlock(), _createBlock(Loader, { key: 0 }))
                : _createCommentVNode("", true)
            ], 2)
          ], 8, _hoisted_8)
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "class"]))
}
}

})